/**
 * Classic O: a funnel of boulders and diamonds over an empty chamber (docs/spec/03 §2). Open the
 * plug under its neck from the side, and every diamond taken from the pile brings more down.
 */

import type { CaveDef } from '../types';

export const caveO: CaveDef = {
  id: 'O',
  name: 'THE CHUTE',
  hint: 'Pull the plug from the side, not from below.',
  intermission: false,
  colors: [11, 13, 1],
  diamondValue: 25,
  extraValue: 45,
  // Only the funnel is random: mostly boulders, two in five diamonds, a little air.
  fill: { base: 'r', items: [['d', 40], [' ', 5]] },
  levels: [
    { seed: 2801, diamonds: 18, time: 130 },
    { seed: 2802, diamonds: 22, time: 120 },
    { seed: 2803, diamonds: 25, time: 110 },
    { seed: 2804, diamonds: 28, time: 100 },
    { seed: 2805, diamonds: 32, time: 90 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W.....w?????????????????????????w......W',
    'W.P....w????????????????r??????w.......W',
    'W.......w????d????????????????w........W',
    'W........w???????????????????w.........W',
    'W.........w?????????????????w..........W',
    'W..........w???????????????w.......d.d.W',
    'W...........w?????????????w............W',
    'W.d.d........w???????????w.............W',
    'W.............w?????????w...........rr.W',
    'W.rr...........w???????w..........wwwwwW',
    'Wwwwww..........w?????w................W',
    'W................w???w.................W',
    'W..dd.............w?w.............dd...W',
    'W.................w....................W',
    'W.........wwwwwwwww wwwwwwwwww.........W',
    'W.........w                  w.........W',
    'W.........w                  w.........W',
    'W....d.d...                  ...d.d....W',
    'W.........w                  w.........W',
    'W.........wwwwwwwwwwwwwwwwwwww.......X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
